export const productRatingOptions =   [{label: 'Good', value: 1}, {label: 'Better', value: 2}, {label: 'Best', value: 3} ]
export const sortOptions = [{label: 'A-Z', value: 'name asc'}, {label: 'Z-A', value: 'name desc'}]
